<div class="flex-1 overflow-hidden">
  <div class="font-bold overflow-hidden whitespace-nowrap overflow-ellipsis">
    {{ resourceTypeDisplayName | translate }}
  </div>
  <div class="overflow-hidden whitespace-nowrap overflow-ellipsis italic">{{ resourceDisplayName }}</div>
</div>
<ng-content></ng-content>
